module.exports = __webpack_public_path__ + "img/promo-ask.35a8b19f.png";